import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Panel from '../../../components/angle/Panel/index';
import DatePicker from '../../../components/DatePicker';
import Select from '../../../components/Select/index';
import { Toastr } from '../../../components/Toastr/index';
import { formInputValidation } from "../../../services/helper/form-helper";

class SalesPanel extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            startDate: '',
            startDatePicker: '',
            endDate: '',
            endDatePicker: '',
            timePeriodSelection: 0,
            selectStateValue: ''
        };
    }
    handleTimePeriodChange = (name, value) => {
        let date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth(),
            d = date.getUTCDate();
        let startDate = '';
        let endDate = new Date();
        if (value) {
            if (value.value === 1) {
                startDate = new Date(Date.UTC(y, m, d - 7));
            } else if (value.value === 2) {
                startDate = new Date(Date.UTC(y, m, d - 30));
            } else if (value.value === 3) {
                startDate = new Date(Date.UTC(y, m, d - 60));
            } else if (value.value === 4) {
                startDate = new Date(Date.UTC(y, m, d - 90));
            }
        }
        this.setState({
            startDate: value && value.value ? startDate : '',
            startDatePicker: '',
            endDate: value && value.value ? endDate : '',
            endDatePicker: '',
            timePeriodSelection: value ? value.value : 0
        });
    };
    handleStateSelectChange = (name, value) => {
        this.setState({
            selectStateValue: value ? value['code'] : ''
        });
    };
    handleDateChange = (name, value) => {
        this.setState({
            [name]: value ? value : ''
        });
    };

    onView = () => {
        let { onViewClick } = this.props;
        let {
            timePeriodSelection,
            startDate,
            endDate,
            startDatePicker,
            endDatePicker,
            selectStateValue
        } = this.state;
        if (formInputValidation(this.formRef.current)) {
            if (timePeriodSelection === 0) {
                if (this.logicValidation()) {
                    let startDatePickerUTC = new Date(startDatePicker);
                    startDatePickerUTC.setUTCHours(0);
                    let endDatePickerUTC = new Date(endDatePicker);
                    endDatePickerUTC.setUTCHours(23, 59, 59);
                    onViewClick(
                        startDatePickerUTC,
                        endDatePickerUTC,
                        selectStateValue
                    );
                }
            } else {
                onViewClick(startDate, endDate, selectStateValue);
            }
        }
    }

    logicValidation = () => {
        let {
            timePeriodSelection,
            startDatePicker,
            endDatePicker
        } = this.state;
        let errorMessage = '';
        if (timePeriodSelection === 0) {
            if (endDatePicker >= startDatePicker) {
                return true;
            } else {
                errorMessage =
                    'End date must be equal or greater than start date';
            }
        }
        Toastr.error(errorMessage);
        return false;
    };

    render() {
        let { stateList } = this.props;
        let { startDatePicker, endDatePicker, timePeriodSelection, selectStateValue } = this.state;
        let viewButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onView}
            >
                View
            </button>
        );
        const buttonList = [viewButton];
        const options = ["Custom Time Period", "Last 7 Days", "Last 30 Days", "Last 60 Days", "Last 90 Days"];
        return (
            <Panel showFooter footerComponents={buttonList}>
                <form ref={this.formRef}>
                <div className="row">
                    <div className="form-group col-md-3">
                        <label>Time Period</label>
                        <Select
                            labelKey="name"
                            valueKey="value"
                            selectedValue={timePeriodSelection}
                            onChange={this.handleTimePeriodChange}
                            options={options.map((option, index) => ({
                                name: option,
                                value: index
                            }))}
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>From</label>
                        <DatePicker
                            id="salesDateStart"
                            name="startDatePicker"
                            value={startDatePicker}
                            onChange={this.handleDateChange}
                            disabled={timePeriodSelection !== 0}
                            required={timePeriodSelection === 0}
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>To</label>
                        <DatePicker
                            id="filingByEffDateEnd"
                            name="endDatePicker"
                            value={endDatePicker}
                            onChange={this.handleDateChange}
                            disabled={timePeriodSelection !== 0}
                            required={timePeriodSelection === 0}
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <label>State</label>
                        <Select
                            labelKey="name"
                            valueKey="code"
                            options={[
                                {
                                    name: "All",
                                    code: ""
                                },
                                ...stateList
                            ]}
                            selectedValue={selectStateValue}
                            onChange={this.handleStateSelectChange}
                        />
                    </div>
                </div>
                </form>
            </Panel>
        );
    }
}

SalesPanel.propTypes = {
    stateList: PropTypes.array.isRequired,
    onViewClick: PropTypes.func.isRequired,
};

export default SalesPanel;


// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/components/SalesPanel.js